import React from 'react'

import { BaseIconProps, IconSizes, IconColors } from '../base'

const Warning: React.FC<BaseIconProps> = React.forwardRef(
  ({ size = 'md', color = 'default', className }, ref) => (
    <svg
      ref={ref}
      className={className}
      width={IconSizes[size]}
      height={IconSizes[size]}
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.97161 9.37842C7.10654 9.37842 7.21592 9.48871 7.21592 9.62477C7.21592 9.76083 7.10654 9.87112 6.97161 9.87112C6.83668 9.87112 6.72729 9.76083 6.72729 9.62477C6.72729 9.48871 6.83668 9.37842 6.97161 9.37842"
        stroke={IconColors[color]}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 7.40848V4.45239"
        stroke={IconColors[color]}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.83798 1.48067C7.6728 1.18478 7.35066 1 7 1C6.64934 1 6.3272 1.18478 6.16202 1.48067L1.10617 10.6962C0.954261 10.9727 0.966043 11.3054 1.13717 11.5715C1.31039 11.8384 1.61571 12.0005 1.94414 12H12.0559C12.3843 12.0005 12.6896 11.8384 12.8628 11.5715C13.034 11.3054 13.0457 10.9727 12.8938 10.6962L7.83798 1.48067Z"
        stroke={IconColors[color]}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
)

export default Warning
